"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rulyotano_math_1 = require("rulyotano.math");
class Point {
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
    equals(otherPoint) {
        return (rulyotano_math_1.Numeric.numericEqual(this.x, otherPoint.x) &&
            rulyotano_math_1.Numeric.numericEqual(this.y, otherPoint.y));
    }
    getHashCode() {
        return (this.x << 10) + this.y;
    }
}
exports.default = Point;
//# sourceMappingURL=Point.js.map